import { render } from "./DetailCreateShipmentNoticeSupp.vue?vue&type=template&id=bbcc594a"
import script from "./DetailCreateShipmentNoticeSupp.vue?vue&type=script&lang=js"
export * from "./DetailCreateShipmentNoticeSupp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__